﻿'use strict';

angular.module('ntmApp').factory('ScenarioChangesListFilter', ['Constants', 'Utils', function (Constants, Utils) {

    function ScenarioChangesListFilter() {

        var self = this;

        self.room = null;
        self.staff = null;
        self.reAssigned = false;
        self.unAssigned = false;
        self.rescheduled = false;
        self.cancelled = false;


        self.filter = function (activities) {
            return activities.filter(validateByFilters);
        };

        function validateByFilters(activity) {

            if (activity.revert) {
                return true;
            }

            if (!Utils.IsTypeheadEmpty(self.staff)) {

                if (activity.currentForecastAssigneeId !== self.staff.id && activity.scenarioAssigneeId !== self.staff.id) {
                    return false;
                }
            }

            if (!Utils.IsTypeheadEmpty(self.room)) {

                if (activity.roomNumber !== self.room.id) {
                    return false;
                }
            }

            var checkBoxValidationOptions = [];

            if (self.reAssigned) {
                checkBoxValidationOptions.push(activity.scenarioAssigneeId && activity.scenarioAssigneeId !== activity.currentForecastAssigneeId);
            }

            if (self.unAssigned) {
                checkBoxValidationOptions.push(!activity.scenarioAssigneeId);
            }

            if (self.rescheduled) {
                checkBoxValidationOptions.push(activity.currentForecastScheduleDate !== activity.scenarioScheduleDate);
            }

            if (self.cancelled) {
                checkBoxValidationOptions.push(activity.scenarioStatusId === Constants.ActivityStatus.Cancelled &&
                                               activity.currentForecastStatusId !== Constants.ActivityStatus.Cancelled);
            }

            if (checkBoxValidationOptions.length > 0 && checkBoxValidationOptions.every(function (option) {
                return !option;
            })) {
                return false;
            }

            return true;
        }
    }

    return (ScenarioChangesListFilter);
}]);